module.exports = __webpack_public_path__ + "officialStatic/img/teacherD.6fb973c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/teacherD.png
// module id = 7Kqc
// module chunks = 0